'use client';

import { useQuery } from '@rocicorp/zero/react';
import {
  isMeasurementSystem,
  type MeasurementSystem
} from '@utils/measurement-system';
import { queries } from './queries';
import { useCurrentUser } from './use-current-user';

/**
 * The measurement system to display ingredient quantities in: the caller's
 * own override (`users.measurementSystem`) if they've set one, else the
 * organization's default, else `'us'`. Both rows are already fully synced
 * by other queries elsewhere in the app (`queries.users.current`,
 * `queries.organizations.current`), so this adds no new server round-trip
 * beyond whatever the page already needs.
 */
export function useEffectiveMeasurementSystem(
  organizationId: string
): MeasurementSystem {
  const currentUser = useCurrentUser();
  const [organization] = useQuery(
    queries.organizations.current({ organizationId })
  );
  const value =
    currentUser?.measurementSystem ?? organization?.measurementSystem;
  return isMeasurementSystem(value) ? value : 'us';
}
